import React from 'react';
import Interweave from 'interweave';
import styles from '../../styles/shipPage.module.sass';
import { Text } from '../Text';
import { Icon } from '../Icon';
// import SeatCountIco from '../../public/icons/seat_count.svg';
// import CauteCountIco from '../../public/icons/caute_count.svg';
import { Button } from '../Button';
import { YaAndGaShipPage } from '../../lib/YaAndGaHelper';
import { IconSVG } from '../SpriteSVG';

export const ShipInfo = ({
  years,
  caute,
  seat,
  description,
  shipType,
  shipHar,
  setClipp,
  clipp,
  construction,
  shipTypeInfo,
  // company,
}) => (
  <div>
    <div className={styles.restavration}>
      <div className={styles.restavrationText}>
        <Text variant="heading-7" className={styles.restavrationText}>
          Модернизация
        </Text>
        <span className={styles.specificationsOneInside}>{years} год</span>
      </div>
      <div className={styles.specificationsOne}>
        Постройка{' '}
        <div className={styles.specificationsOneInside}>{construction} год</div>
      </div>
    </div>

    <div className={styles.count}>
      <div className={styles.countInfo}>
        <Icon
          icon={<IconSVG name={'promo/caute_count'} width={24} height={24} />}
        />
        <Text className={styles.countInfoText}>Общее количество кают</Text>
        <Text className={styles.countInfoText} variant="vosclic">
          {caute}
        </Text>
      </div>
      <div className={styles.countInfo}>
        <Icon
          icon={<IconSVG name={'promo/seat_count'} width={24} height={24} />}
        />
        <Text className={styles.countInfoText}>Вместимость (человек)</Text>
        <Text className={styles.countInfoText} variant="vosclic">
          {seat}
        </Text>
      </div>
    </div>
    <div className={!clipp ? styles.shipDesc : styles.shipDescOff}>
      {description || description}
    </div>
    <div>
      {!clipp ? (
        <Button
          onClick={() => {
            setClipp(true);
            // if (shipType !== 'sea')
            //   YaAndGaShipPage('click_open_description_ship');
          }
        }
        >
          Открыть описание {shipTypeInfo}
        </Button>
      ) : (
        <Button
          onClick={() => {
            setClipp(false);
            if (shipType !== 'sea')
              YaAndGaShipPage('click_h_description_shipide');
          }}
        >
          Скрыть описание {shipTypeInfo}
        </Button>
      )}
    </div>
    {/* <div className={styles.company}>
      <Text variant="heading-8" color="darken">
        Туроператор {company}
      </Text>
    </div> */}
    <div className={styles.specification}>
      <Text variant="heading-7">
        Характеристики {shipType === 'sea' ? 'лайнера' : 'теплохода'}
      </Text>
      <div className={styles.specifications}>
        <div className={styles.specificationsOne}>
          Длина{' '}
          <div className={styles.specificationsOneInside}>{shipHar[0]} м.</div>
        </div>
        <div className={styles.specificationsOne}>
          Ширина{' '}
          <div className={styles.specificationsOneInside}>{shipHar[1]} м.</div>
        </div>
        <div className={styles.specificationsOne}>
          Осадка{' '}
          <div className={styles.specificationsOneInside}>{shipHar[2]} м.</div>
        </div>
      </div>
    </div>
  </div>
);
